export const FaqBaseRoute = "/fragen-und-antworten";
export const FaqBaseRedirectRoute = "/fragen-und-antworten/wechselablauf";
